import React, {useContext} from "react"
import {Box} from "@mui/material"
import {useDraggable} from "@dnd-kit/core"
import {CSS} from "@dnd-kit/utilities"
import {ActionContext} from "../../../src/context/ActionContextProvider"

const DraggableEvent = ({
                            item,
                            children,
                            defaultPosition,
                            getDataFromPointer,
                            doubleClickAction
                        }) => {
    const {x = 0, y = 0} = item.position || defaultPosition
    const {triggerAction} = useContext(ActionContext)
    const {attributes, listeners, setNodeRef, transform, isDragging} =
        useDraggable({id: item.id})
    const currentTransform = {
        x: x + (transform ? transform.x : 0),
        y: y + (transform ? transform.y : 0),
        scaleX: 1,
        scaleY: 1,
    }

    const isInBoard = () => {
        const {width, height} = getDataFromPointer("/appstate/lebensmeilensteine/container")
        const realY = y * -1
        return x <= width && x >= 0 && realY >= 0 && realY <= height
    }

    const baseStyle = {
        position: "absolute",
        transform: CSS.Translate.toString(currentTransform),
        opacity: isDragging ? 0.6 : 1,
        cursor: "grab",
        transition: isDragging ? "none" : "transform 0.2s ease-out",
        boxShadow: isDragging
            ? "0 8px 16px rgba(0,0,0,0.3)"
            : "0 1px 3px rgba(0,0,0,0.1)",
        zIndex: isDragging ? 1000 : 900,
        width: `80px`,
        height: `80px`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "8px",
    }

    const outOfBoardStyle = {
        ...baseStyle,
        backgroundColor: "#CDD5F4",
        color: "#072ECA",
        border: `1px solid #CDD5F4`,

    }

    const inBoardStyle = {
        ...baseStyle,
        backgroundColor: "transparent",
        color: "#072ECA",
        border: `1px solid #072ECA`,
    }

    return (
        <Box ref={setNodeRef} onDoubleClick={() => triggerAction(doubleClickAction, item)}
             style={isInBoard() ? inBoardStyle : outOfBoardStyle} {...listeners} {...attributes}>
            {children}
        </Box>
    )
}

export default DraggableEvent
